import { render, staticRenderFns } from "./CountUpNumber.vue?vue&type=template&id=6cd38496&"
import script from "./CountUpNumber.vue?vue&type=script&lang=js&"
export * from "./CountUpNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports